/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import store from '@/store';
import * as api from '@/api/play';
import { PLAY } from '@/store/types';

export interface StorePlayServiceAdminState {}

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    [PLAY.MODIFY_SERVICE](_, { id, body, userid }) {
      return new Promise((resolve, reject) => {
        api.putService(id, body).then(() => {
          const oncomplete = (): void => resolve();
          Promise.all([
            store.dispatch(`play/service/detail/${PLAY.GET_SERVICE}`, { id, action: 'refresh' }),
            store.dispatch(`play/service/mine/${PLAY.GET_SERVICES}`, { action: 'refresh' }),
            store.dispatch(`play/service/other/${PLAY.GET_SERVICES}`, { id: userid, action: 'refresh' }),
          ]).then(oncomplete).catch(oncomplete);
        }).catch(reject);
      });
    },
  },
};
